<div class="container row">

  <app-config-line
    [title]="'Resumen de Registros'"
    [titleLevel]="7"
    [withHr]="false"
  >
  </app-config-line>

  <app-config-line
    [title]="
      ('CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.VEHICLES.LABEL' | translate)
      + ' ' + userInfoForm.vehiclesLenght
      + ' ' + ('GENERAL.RECORDS' | translate)
    "
    [description]="'CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.VEHICLES.DESCRIPTION' | translate"
  ></app-config-line>

  <app-config-line
    [title]="
      ('CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.GEOPOINTS.LABEL' | translate)
      + ' ' + userInfoForm.geopointsLenght
      + ' ' + ('GENERAL.RECORDS' | translate)
    "
    [description]="'CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.GEOPOINTS.DESCRIPTION' | translate"
  ></app-config-line>

  <app-config-line
    [title]="
      ('CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.POLYGON_GEOFENCES.LABEL' | translate)
      + ' ' + userInfoForm.geocercaPoligLenght
      + ' ' + ('GENERAL.RECORDS' | translate)
    "
    [description]="'CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.POLYGON_GEOFENCES.DESCRIPTION' | translate"
  ></app-config-line>

  <app-config-line
    [title]="
      ('CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.CIRCLE_GEOFENCES.LABEL' | translate)
      + ' ' + userInfoForm.geocercaCircLenght
      + ' ' + ('GENERAL.RECORDS' | translate)
    "
    [description]="'CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.CIRCLE_GEOFENCES.DESCRIPTION' | translate"
  ></app-config-line>

  <app-config-line
    [title]="
      ('CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.EVENTS.LABEL' | translate)
      + ' ' + userInfoForm.eventosLenght
      + ' ' + ('GENERAL.RECORDS' | translate)
    "
    [description]="'CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.EVENTS.DESCRIPTION' | translate"
  >
    <p-dropdown 
      [options]="events" 
      [appendTo]="'body'" 
      [group]="true" 
      [placeholder]="'EVENTS.LABELS.AVAILABLE_EVENTS' | translate" 
      [emptyMessage]="'EVENTS.LABELS.NO_EVENTS' | translate" 
      optionLabel="name" 
      [style]="{'max-height':'200px','max-width':'200px'}">
      <ng-template let-group pTemplate="group">
        <div class="p-d-flex p-ai-center">
          <span>{{group.label}}</span>
        </div>
      </ng-template>
    </p-dropdown>
  </app-config-line>

  <app-config-line
    [title]="
      ('CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.REPORTS.LABEL' | translate)
      + ' ' + userInfoForm.reportesLenght
      + ' ' + ('GENERAL.RECORDS' | translate)
    "
    [description]="'CONFIGURATION.SECTIONS.USER.PLATFORM_INFO.REPORTS.DESCRIPTION' | translate"
  >
    <p-dropdown 
      [options]="reports" 
      [appendTo]="'body'" 
      [placeholder]="'REPORTS.LABELS.REPORT_LIST' | translate" 
      [emptyMessage]="'REPORTS.LABELS.NO_REPORTS' | translate" 
      optionLabel="name_report" 
      [style]="{'max-height':'200px','max-width':'200px'}">
    </p-dropdown>
  </app-config-line>

</div>
